module.exports = __webpack_public_path__ + "img/teen-patti_T20.c95afd6.jpg";